<template>
  <a href="#" class="mr-2" v-if="active" @click.prevent="show()">
    <Icon name="notificationMessage" width="24"/>
  </a>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "FixedNotification",
  computed: {
    ...mapGetters('checkinDetail', ['eventPopup']),
    active() {
      return this.eventPopup.fixed.active === true
    },
  },
  methods: {
    show() {
      this.$bvModal.show("modal-fixed-popup")
    },
  },
}
</script>


<style scoped>

</style>